import React from "react";
import FadingCarousel from "../FadingCarousel/FadingCarousel";
import Connect from "../Connect/Connect";
import "./Javascript.css";
import EsPatterns from "../EsPatterns/EsPatterns";

// By extending the React.Component class, TextArea inherits functionality from it
class Javascript extends React.Component {

    constructor(props) {

        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the TextArea component
        this.state =
            {
                initial: false
            };

    } // End of constructor() 

    render() {

        return (

            <div className="row">
                <div className="col-md-8 TlDrMain">

                    <FadingCarousel name="sam"
                        componentArray=
                        {
                            [
                                <EsPatterns name="esPatterns" />,
                                
                            ]

                        }
                        labelArray=
                        {
                            [
                                "Design Patterns",
                                
                            ]
                        }
                    />
                </div>

                <div className="col-md-3 sam">

                    <div className="row">
                        <div className="col-md-12">
                            <Connect />
                        </div>
                    </div>

                </div>
            </div>
        )
    } // End of render

} // End of class Javascript

export default Javascript;


// WEBPACK FOOTER //
// ./src/components/Javascript/Javascript.js